export const LAB_TEST_PAGE = '/lab-test'
export const LAB_TEST_SINGLE_ITEM_PAGE = '/lab-test/single-item'
export const LAB_TEST_INFO_PAGE = '/lab-test/info'
export const LOGIN_PAGE = '/login'
export const DASHBOARD_PAGE = '/dashboard'
export const DINING_PAGE = '/dining'
export const DINING_CHECK_IN_PAGE = '/dining/check-in'
export const DINING_MEAL_SETUP_PAGE = '/dining/meal-setup'
export const MONITOR_SYSTEM_PAGE = '/monitor-system'
export const STICKER_PRINTING_PAGE = '/sticker-printing'
export const SETTING_PAGE = '/setting'
export const PRINTING_STICKER_TEST_PAGE = '/sticker-printing-test'
export const KIOSK_PAGE = '/kiosk'
export const QUEUE_MANAGEMENT_PAGE = '/queue-management'
export const RECEPTION_PAGE = '/reception'
export const MEMBER_PROFILE_PAGE = '/member-profile'
export const IT_MONITOR_ROOM_PAGE = '/it-monitor-room'
export const RADIOLOGY_REPORTING_PAGE = '/radiology-reporting'
export const TEST_PDPA_PAGE = '/test-pdpa'
export const IT_ROOM_PRINTING_PAGE = '/it-room-printing'
export const PHYSICIAN_CONSULTATION_PAGE = '/physician-consultation'
export const PHYSICIAN_CONSULTATION_INFO_PAGE = '/physician-consultation-info'
export const STAFF_MANAGEMENT_PAGE = '/staff-management'
export const STAFF_PROFILE_PAGE = '/staff-profile'
export const STAFF_PROFILE_NEW_PAGE = '/staff-profile-new'
export const HEALTH_MANAGEMENT_CONSULTATION_PAGE =
    '/health-management-consultation'
export const HEALTH_MANAGEMENT_CONSULTATION_INFO_PAGE =
    '/health-management-consultation-info'
export const MUL_REPORT_PAGE = '/MUL-report'
export const PHONE_CONSULTATION_PAGE = '/phone-consultation'
export const PHONE_CONSULTATION_DISTRIBUTE_PAGE =
    '/phone-consultation-distribute'
export const DIETARY_LIFE_STYLE_PAGE = '/dietary-life-style'
export const MAIN_INGREDIENT = '/main-ingredient'
export const NUTRIENT = '/nutrient'
export const ROOM_MANAGEMENT_PAGE = '/room-management'

const SCREENING_ROOM_SYSTEM_PAGE = '/screening-room-system'
export const SONOGRAPHY_PAGE = SCREENING_ROOM_SYSTEM_PAGE + '/sonography'
export const BONE_MINERAL_DENSITY_PAGE =
    SCREENING_ROOM_SYSTEM_PAGE + '/bone-mineral-density'
export const INTERVIEW_PAGE = SCREENING_ROOM_SYSTEM_PAGE + '/interview'
export const INTERVIEW_INFO_PAGE = INTERVIEW_PAGE + '/interview-info'
export const AUDIOMETRY_PAGE = SCREENING_ROOM_SYSTEM_PAGE + '/audiometry'
export const ELECTROCARDIOGRAM_PAGE =
    SCREENING_ROOM_SYSTEM_PAGE + '/electrocardiogram'
export const ENT_EXAMINATION_PAGE =
    SCREENING_ROOM_SYSTEM_PAGE + '/ent-examination'
export const CT_SCAN_PAGE = SCREENING_ROOM_SYSTEM_PAGE + '/ct-scan'
export const GENERAL_MEASUREMENT_PAGE =
    SCREENING_ROOM_SYSTEM_PAGE + '/general-measurement'
export const LUNG_FUNCTION_TEST_PAGE =
    SCREENING_ROOM_SYSTEM_PAGE + '/lung-function-test'
export const MAMMOGRAPHY_PAGE = SCREENING_ROOM_SYSTEM_PAGE + '/mammography'
export const PERIPHERAL_VASCULAR_SCREENING_PAGE =
    SCREENING_ROOM_SYSTEM_PAGE + '/peripheral-vascular-screening'
export const PAPS_SMEAR_PAGE = SCREENING_ROOM_SYSTEM_PAGE + '/paps-smear'
export const RETINOGRAPHY_PAGE = SCREENING_ROOM_SYSTEM_PAGE + '/retinography'
export const VISION_AND_OCULAR_TENSION_TEST_PAGE =
    SCREENING_ROOM_SYSTEM_PAGE + '/vision-and-ocular-tension-test'
export const X_RAY_PAGE = SCREENING_ROOM_SYSTEM_PAGE + '/x-ray'
export const VIEW_COMMENT_PAGE = SCREENING_ROOM_SYSTEM_PAGE + '/view-comment'
export const INTERVIEW_QUESTIONAIRE_PAGE = '/questionaire'
export const FINAL_REPORT = '/final-report'
export const FINAL_REPORT_INTERVIEW_PAGE = FINAL_REPORT + '/interview'
export const FINAL_REPORT_HMP_BROCHURE = FINAL_REPORT + '/hmp-brochure'
export const FINAL_REPORT_PAPS_SMEAR = FINAL_REPORT + '/paps-smear'
export const FINAL_REPORT_PAPS_SMEAR_EXAM = FINAL_REPORT + '/paps-smear-exam'
export const FINAL_REPORT_HMC_RECORD = FINAL_REPORT + '/hmc-record'
export const FINAL_REPORT_MPA = FINAL_REPORT + '/mpa'
export const FINAL_REPORT_AUDIOMETRY = FINAL_REPORT + '/audiometry'
export const FINAL_REPORT_BONE_MINERAL_DENSITY =
    FINAL_REPORT + '/bone-mineral-density'
export const FINAL_REPORT_CT_SCAN = FINAL_REPORT + '/ct-scan'
export const FINAL_REPORT_ENT_EXAMINATION = FINAL_REPORT + '/ent-examination'
export const FINAL_REPORT_ELECTROCARDIOGRAM =
    FINAL_REPORT + '/electrocardiogram'
export const FINAL_REPORT_GENERAL_MEASUREMENT =
    FINAL_REPORT + '/general-measurement'
export const FINAL_REPORT_MAMMOGRAPHY = FINAL_REPORT + '/mammography'
export const FINAL_REPORT_LUNG_FUNCTION_TEST =
    FINAL_REPORT + '/lung-function-test'
export const FINAL_REPORT_PERIPHERAL_VASCULAR_SCREENING =
    FINAL_REPORT + '/peripheral-vascular-screening'
export const FINAL_REPORT_RETINOGRAPHY = FINAL_REPORT + '/retinography'
export const FINAL_REPORT_SONOGRAPHY = FINAL_REPORT + '/sonography'
export const FINAL_REPORT_VISION_AND_OCULAR_TENSION_TEST =
    FINAL_REPORT + '/vision-and-ocular-tension-test'
export const FINAL_REPORT_X_RAY = FINAL_REPORT + '/x-ray'
export const FINAL_REPORT_SUPPLEMENTARY_REPORT =
    FINAL_REPORT + '/supplementary-report'
